import { http } from "~/utils";
import * as moment from "moment";

export default {
    download: async (run, oet) => {
        return http
            .get(`/india/run/${run.id}/export-oet-non-sode/`, {
                responseType: "blob"
            })
            .then(response => {
                if (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    const name = oet.name ? `${oet.name}` : `OET-${oet.id}-RUN-${run.id}`;
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `ZINA_NON_SODE_${name}${run.vpo_count !== null ? `_${run.vpo_count}` : ""}_${moment(run.created_at).format(
                            "DD-MM-YYYY"
                        )}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                }
            });
    },
    getRegions: () => {
        return http.get("/voa/summary/regions/").then(response => response.data);
    },
    syncVoaNonSode: (run_id, voa_items_ids) => {
        return http.post(`/india/run/${run_id}/sync-voa-non-sode/`, { voa_items_ids }).then(response => response.data);
    },
    send_create_scratch_po_job: (run_id) => {
        return http.post(`/india/non-sode/non-sode/request-scratch-po-india-job/${run_id}/`).then(response => response.data);
    },
    send_grn_job:(run_id, items=null)=>{
        return http.post(`/india/non-sode/non-sode/request-grn-job/${run_id}/`, items)
        .then(response => response.data)
        .catch(error => error);
    },
    //THIS IS FOR GRN AND GRN REVERSAL, AND CANCEL PO
    send_items_selected_job:(run_id, data=null, path)=>{
        return http.post(`/india/non-sode/non-sode/${path}/${run_id}/`, data)
        .then(response => response.data)
        .catch(error => error);
    },
    get_sap_history:(run_id)=>{
        return http.get(`/india/non-sode/non-sode/request-sap-history/${run_id}/`)
        .then(response => response.data)
        .catch(error => error);
    },
    get_confirmation_info_scratch_po: (run_id) => {
        return http.get(`/india/non-sode/non-sode/confirmation-info-scratch-po/${run_id}/`).then(response => response.data);
    },
    send_confirmation_info_scratch_po: (run_id, currency) => {
        return http.post(`/india/non-sode/non-sode/request-scratch-po-india-job/${run_id}/`, {currency}).then(response => response.data);
    }
};
